// Game viewport sizing - scales with window, capped at max
export const TILE_SIZE = 16;
export const MIN_GAME_SIZE = 640;  // Minimum viewport (40 tiles)
export const MAX_GAME_SIZE = 1200; // Maximum viewport (~75 tiles)
export const UI_MARGIN = 140;      // Space for left sidebar + padding

// Calculate initial game size based on window
export const getGameSize = (): number => {
  const availableWidth = window.innerWidth - UI_MARGIN;
  const availableHeight = window.innerHeight - 80; // Top/bottom padding
  const size = Math.min(availableWidth, availableHeight);
  // Snap to tile grid and clamp
  const snapped = Math.floor(size / TILE_SIZE) * TILE_SIZE;
  return Math.max(MIN_GAME_SIZE, Math.min(MAX_GAME_SIZE, snapped));
};

export const CHUNK_SIZE = 1000; // Chunk size in pixels (doubled from 500)
export const WORLD_CHUNKS = 8; // 8x8 chunks = 8000x8000 world

// World regions - 8x8 grid of chunks
// Layout: '+' pattern for cardinal Reaches, corners have unique biomes, Arcadia at center
// Chunk coords: (col, row) where row 0 = north (top), row 7 = south (bottom)
export const REGIONS = [
  // Cardinal directions ('+' pattern around Arcadia)
  { id: 'northern_reach', name: 'Northern Reach', color: '#1abc9c', chunks: [[3,0],[4,0],[3,1],[4,1],[3,2],[4,2]] },
  { id: 'southern_reach', name: 'Southern Reach', color: '#e67e22', chunks: [[3,5],[4,5],[3,6],[4,6],[3,7],[4,7]] },
  { id: 'eastern_reach', name: 'Eastern Reach', color: '#3498db', chunks: [[5,3],[6,3],[7,3],[5,4],[6,4],[7,4]] },
  { id: 'western_reach', name: 'Western Reach', color: '#9b59b6', chunks: [[0,3],[1,3],[2,3],[0,4],[1,4],[2,4]] },
  // Corner regions (new biomes/themes)
  { id: 'frostwind_isles', name: 'Frostwind Isles', color: '#a8d8ea', chunks: [[0,0],[1,0],[2,0],[0,1],[1,1],[2,1],[0,2],[1,2],[2,2]] },
  { id: 'sunfire_archipelago', name: 'Sunfire Archipelago', color: '#ff6b6b', chunks: [[5,0],[6,0],[7,0],[5,1],[6,1],[7,1],[5,2],[6,2],[7,2]] },
  { id: 'stormveil_depths', name: 'Stormveil Depths', color: '#4a4e69', chunks: [[0,5],[1,5],[2,5],[0,6],[1,6],[2,6],[0,7],[1,7],[2,7]] },
  { id: 'golden_shoals', name: 'Golden Shoals', color: '#ffd93d', chunks: [[5,5],[6,5],[7,5],[5,6],[6,6],[7,6],[5,7],[6,7],[7,7]] },
  // Center region
  { id: 'arcadia', name: 'Arcadia', color: '#e74c3c', chunks: [[3,3],[4,3],[3,4],[4,4]] },
];

// Get region for a chunk coordinate
export const getChunkRegion = (col: number, row: number): { color: string; id: string; name: string } | null => {
  for (const region of REGIONS) {
    if (region.chunks.some(([c, r]) => c === col && r === row)) {
      return { color: region.color, id: region.id, name: region.name };
    }
  }
  return null;
};

